import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlane, faBed, faCar, faCompass } from '@fortawesome/free-solid-svg-icons';
import { Eyebrow, INK, MUTED } from '../Landing/ui';
import {
  activitiesLink,
  carRentalLink,
  flightsLink,
  staysLink,
} from 'helpers/affiliateLinks';

// Booking desk: the four paper chips that used to pre-fill the travel chatbot,
// now pointing straight at the partners. Only Things to do can carry the
// destination — the rest of our approved programs take no place parameter, so
// they land on the partner's own search. The partner name is the sub-label
// rather than a generic "Book": readers should see where a chip sends them
// before they click it. The page's affiliate disclosure sits below the map.
export default function BookingDesk({ locationString }) {
  const desk = [
    {
      label: 'Flights',
      partner: 'Kiwi.com',
      icon: faPlane,
      href: flightsLink(),
    },
    {
      label: 'Things to do',
      partner: 'GetYourGuide',
      icon: faCompass,
      href: activitiesLink(locationString),
    },
    {
      label: 'Stays',
      partner: 'Hostelworld',
      icon: faBed,
      href: staysLink(locationString),
    },
    {
      label: 'Car rental',
      partner: 'DiscoverCars',
      icon: faCar,
      href: carRentalLink(),
    },
  ];

  return (
    <div>
      <Eyebrow className="tw-mb-3">The booking desk</Eyebrow>
      <div className="tw-grid tw-grid-cols-2 tw-gap-3 sm:tw-grid-cols-4">
        {desk.map(item => {
          return (
            <a
              key={item.label}
              href={item.href}
              target="_blank"
              rel="sponsored noreferrer nofollow"
              className="tw-block tw-cursor-pointer tw-rounded-2xl tw-border tw-border-solid tw-border-[#E7E0CF] dark:tw-border-[#26382F] tw-bg-white dark:tw-bg-[#15231E] tw-px-4 tw-py-5 tw-text-center tw-no-underline tw-transition-all tw-duration-200 hover:-tw-translate-y-0.5 hover:tw-border-primary-600 dark:hover:tw-border-primary-300"
            >
              <FontAwesomeIcon
                icon={item.icon}
                className="tw-h-6 tw-w-6 tw-text-primary-700 dark:tw-text-primary-300"
              />
              <div className={`${INK} tw-mt-2 tw-text-[15px] tw-font-semibold`}>
                {item.label}
              </div>
              <div
                className={`${MUTED} tw-mt-0.5 tw-font-mono tw-text-[9px] tw-uppercase tw-tracking-[0.2em]`}
              >
                {item.partner}
              </div>
            </a>
          );
        })}
      </div>
    </div>
  );
}
